import * as React from "react"

const Etherscan = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M4.494 7.714a.508.508 0 0 1 .511-.508l.847.002a.51.51 0 0 1 .51.51v3.204c.095-.029.217-.059.352-.09a.425.425 0 0 0 .326-.413V6.444a.51.51 0 0 1 .51-.51h.85a.51.51 0 0 1 .51.51v3.69s.212-.087.419-.175a.425.425 0 0 0 .259-.391V5.17a.509.509 0 0 1 .51-.509h.848a.509.509 0 0 1 .51.51v3.62c.736-.533 1.481-1.174 2.073-1.946a.855.855 0 0 0 .13-.799 5.99 5.99 0 0 0-5.582-4.045C4.749 1.957 2 4.673 2 8a5.983 5.983 0 0 0 .797 3.001.758.758 0 0 0 .723.375c.16-.014.36-.034.598-.062a.424.424 0 0 0 .377-.42v-3.18h-.001Zm-.018 5.139a5.996 5.996 0 0 0 9.51-5.263c-2.191 3.269-6.238 4.797-9.51 5.263" />
  </svg>
)

export default Etherscan
